import React, { useMemo } from "react";
import { Route, useLocation } from "react-router-dom";
import DataTable from "../_Components/DataTable";
import ModalPortal from "./Component/ModalPortal";
import Switch from "@mui/material/Switch";
import { Button } from "react-bootstrap";

function DataGridPayment({ data, setShowModalPortal, setSelectedPortalId }) {
  let location = useLocation();
  let background = location.state && location.state.background;
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "#",
      minWidth: 50,
    },
    {
      accessor: "title",
      Header: "نام بانک",
      minWidth: "100px",
    },
    {
      accessor: "titleShow",
      Header: "عنوان نمایشی",
      minWidth: "100px",
    },
    {
      Header: "وضعیت",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.status ? true : false}
            //checked={state.checkedA}
            value="row.original.active"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            // onChange={handleChange(row.original)}
          />
        </div>
      ),
    },
    {
      accessor: "indexView",
      Header: "اولویت نمایش",
      minWidth: "100px",
    },
    {
      accessor: "lastOrderId",
      Header: "lastOrderId",
      minWidth: "100px",
    },

    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Button
            title="ویرایش"
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedPortalId(row.original.id);
              setShowModalPortal(true);
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
          {/* ویرایش */}
          {/* <a className="btn btn-light-primary btn-sm mr-2 btn-icon" href={`/viewOrderContents/${row.original.id}`}   >
                                    <i className='far fa-edit text-small'></i>
                            </a> */}
          {/* <Link  to={`/viewOrderContents/${row.original.id}`}><i className='far fa-edit text-small'></i></Link> */}
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };

  return (
    <div>
      {background && <Route path="/portals/modalPortal" children={<ModalPortal />} />}
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridPayment;
